module.exports = __webpack_public_path__ + "static/media/morvan.365ef4a3.jpeg";